(() => {
  const GIF_URL_PATTERN = /\.gif(?:$|[?#&,\s])/i;
  const INITIALIZED_ATTRIBUTE = 'data-gif-animation-initialized';

  function isGif(image) {
    return [
      image.currentSrc,
      image.src,
      image.getAttribute('src'),
      image.getAttribute('srcset'),
    ].some((source) => source && GIF_URL_PATTERN.test(source));
  }

  function setControlState(container, button, isPlaying) {
    container.classList.toggle('gif-animation--paused', !isPlaying);
    button.classList.toggle('gif-animation__control--paused', !isPlaying);
    button.setAttribute(
      'aria-label',
      isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel
    );
  }

  function addControl(image, instance, preferredWidth) {
    const container = image.parentElement;
    const template = document.getElementById('GifAnimationControlTemplate');

    if (
      !container ||
      !container.classList.contains('ff-ready') ||
      container.hasAttribute('data-gif-animation-control') ||
      !template
    ) {
      return;
    }

    container.setAttribute('data-gif-animation-control', '');
    container.style.width = preferredWidth;

    const control = template.content.cloneNode(true);
    const button = control.querySelector('.gif-animation__control');
    if (!button) return;

    container.appendChild(button);

  instance.start();

    // FreezeFrame captures the canvas at CSS-pixel size and, on lazy images,
    // sometimes at the wrong aspect ratio. Redraw at the GIF's natural
    // resolution so the paused frame is sharp and correctly proportioned.
    const canvas = container.querySelector('.ff-canvas');
    if (canvas && image.naturalWidth && image.naturalHeight) {
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      canvas.getContext('2d').drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight);
    }

    setControlState(container, button, true);

    button.addEventListener('click', () => {
      const isPlaying = !container.classList.contains('gif-animation--paused');

      if (isPlaying) {
        instance.stop();
      } else {
        instance.start();
      }

      setControlState(container, button, !isPlaying);
    });
  }

  function enhanceGif(image) {
  if (
    !(image instanceof HTMLImageElement) ||
    image.hasAttribute(INITIALIZED_ATTRIBUTE) ||
    !isGif(image) ||
    typeof window.Freezeframe !== 'function'
  ) {
    return;
  }

  // Lazy-loaded GIFs have a layout box before they have pixel data.
  // Capturing before load produces a blank paused frame, so wait.
  if (!image.complete || image.naturalWidth === 0) {
    if (!image.hasAttribute('data-gif-animation-pending')) {
      image.setAttribute('data-gif-animation-pending', '');
      image.addEventListener(
        'load',
        () => {
          image.removeAttribute('data-gif-animation-pending');
          enhanceGif(image);
        },
        { once: true }
      );
    }
    return;
  }

  const imageBounds = image.getBoundingClientRect();
  if (!imageBounds.width || !imageBounds.height) {
    return;
  }

  image.setAttribute(INITIALIZED_ATTRIBUTE, '');

    const imageWidth = imageBounds.width;
    const parentWidth = image.parentElement ? image.parentElement.clientWidth : 0;
    const fillsParent = parentWidth > 0 && Math.abs(parentWidth - imageWidth) <= 1;
    const preferredWidth = fillsParent || !imageWidth ? '100%' : `${Math.ceil(imageWidth)}px`;
    const originalParent = image.parentElement;
    const instance = new window.Freezeframe(image, {
      overlay: false,
      responsive: true,
      trigger: false,
      warnings: false,
    });

    const readyObserver = new MutationObserver(() => {
      const container = image.parentElement;

      if (container && container.classList.contains('ff-ready')) {
        readyObserver.disconnect();
        addControl(image, instance, preferredWidth);
      }
    });

    if (originalParent) {
      readyObserver.observe(originalParent, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
      });
    }
  }

  function scanForGifs(root = document) {
    if (root instanceof HTMLImageElement) {
      enhanceGif(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('img').forEach(enhanceGif);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    scanForGifs();

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => scanForGifs(), 100);
    });

    const pageObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          enhanceGif(mutation.target);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            scanForGifs(node);
          }
        });
      });
    });

    pageObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['src', 'srcset'],
      childList: true,
      subtree: true,
    });
  });
})();
